import ES from './es';
import EN from './en';

const management = {
    ES,
    EN
};

export default management;
